module.exports = __webpack_public_path__ + "static/media/Camera10.56395faa.jpg";